module.exports = require('./lib/main')



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/index.js
// module id = QttI
// module chunks = 0